import * as SystemActions from './../../system/actions/system.actions';
import { initialBankDetailsState, IBankDetailsState } from "../../state/bank-details.state";
import * as registrationActions from '../actions/registration.actions';

export function BankDetailsReducer(state = initialBankDetailsState, action: registrationActions.RegistrationActions | SystemActions.SystemActions): IBankDetailsState {
    switch (action.type) {
        case registrationActions.REGISTER_LOAD_STEPS_SUCCESS: {
            const { bankDetails } = action.payload.registration;
            return {
                ...state,
                details: bankDetails,
                failText: null
            };
        }

        case registrationActions.REGISTER_UPDATE_BANK_DETAILS: {
            return {
                ...state,
                details: action.payload.details,
                failText: null
            };
        }

        case SystemActions.CLEAR_SYSTEM:
            return initialBankDetailsState;

        default:
            return state;
    }
}
